import { ZfIcon, ZfTooltip } from '@zafire/react';
import type { ICellRendererParams } from 'ag-grid-enterprise';
import type { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import type { BalanceSheetTableData } from '../../../interfaces/balance-sheet-table';
import { concatClean, formatPortfolioNumber } from '../../../utils/utils';
import { TruncatedCellText } from './TruncatedCellText';

export const BalanceSheetTableInstitutionCell: FunctionComponent<ICellRendererParams<BalanceSheetTableData>> = ({ data, value, setTooltip }) => {
    const { t } = useTranslation();

    if (!data) return null;

    return (
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', width: '100%', minWidth: 0 }}>
            {data.expired && (
                <ZfTooltip text={t('wealthBalanceEntryExpired')}>
                    <ZfIcon slot={'anchor'} size={'large'} name={'warning'} style={{ color: 'var(--fg-color-warning-normal)' }} />
                </ZfTooltip>
            )}
            <TruncatedCellText
                text={concatClean(value ?? '', formatPortfolioNumber(data.portfolioNumber, data.businessRelationId, data.portfolioIdentifier))}
                setTooltip={setTooltip}
                fontVariant="body-medium"
                style={{ flex: 1, minWidth: 0 }}
            />
        </div>
    );
};
